import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { FooterLinks } from 'globals/store/publish.data';

@Component({
    selector: 'footer-links',
    template: `
<div *ngFor="let link of footerLinks.links" class="footer-link" (click)="publicHelpers.openInNewTab(link.linkUrl || '')">{{ link.filename || 'Unnamed Link' }}</div>
  `,
    styles: [`
  :host { display: flex; flex-wrap: wrap; justify-content: center; text-align: center;}
  .footer-link { color: var(--link); width: 250px; margin: 10px 5px; cursor: pointer; }
  .footer-link:hover { color: var(--highlight); text-decoration: underline; }
`],
    standalone: true,
    imports: [CommonModule],
})
export class FooterLinksComponent {
  publicHelpers = publicHelpers
  @Input() footerLinks: FooterLinks
}